import React from 'react';
import styles from './SkeletonCard.module.css';

const SkeletonCard: React.FC = () => (
    <div className={styles.card} aria-hidden="true">
        <div className={styles.icon} />
        <div className={styles.body}>
            <div className={`${styles.block} ${styles.line} ${styles.short}`} />
            <div className={`${styles.block} ${styles.line}`} />
        </div>
    </div>
);

export default SkeletonCard;
